export default __webpack_public_path__ + "static/media/xt.963c5677.svg";